module.exports = __webpack_public_path__ + "static/media/Onu.36bc4896.png";